import { Box, Typography } from '@mui/material';
import { Constants } from '../../shared/constants';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { getFormattedDate, getFormattedTime } from '../../shared/formatter';
import useAuthStore from '../../store/useAuthStore';
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi';

const ProfilePicture = ({ profileDetail }) => {
  const { user } = useAuthStore();
  const { data: userDetail } = useGetUserDetail()


  return (
    <Box
      sx={{
        height: { lg: '180px', xs: "auto" },
        background: `linear-gradient(271.56deg, rgba(65, 105, 225, 0) 0.11%, #4169E1 100%), url(${Constants.customImages.StudentProfileBG})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
        zIndex: 100,
        p: { lg: "0", xs: "20px" },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: "column", alignItems: 'start', justifyContent: 'center' }}>
        <Typography variant='h3' color='text.secondary' textTransform={"capitalize"}>Welcome, {`${user?.role !== "student" ? userDetail?.data?.firstname : ""} ${userDetail?.data?.lastname}`}!</Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: { lg: 3, xs: 1 }, my: 1 }}>
          {profileDetail.map((item, index) => (
            <Typography variant='h4' color='text.secondary' key={index}>
              {item.name} : {item.value}
            </Typography>
          ))}
        </Box>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: { lg: 3, xs: 1 }, alignItems: "center" }}>
          <Typography variant='h4' color='text.secondary' sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CalendarTodayIcon fontSize="small" /> {getFormattedDate()}
          </Typography>
          <Typography variant='h4' color='text.secondary' sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AccessTimeIcon fontSize="small" /> {getFormattedTime()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfilePicture;
